import { Paginate as ReactPaginate } from 'react-paginate-chakra-ui';

import { Flex } from '@chakra-ui/react';

import config from 'config';

const Paginate = ({
  page,
  count,
  onSetPage,
  pageSize,
}: {
  page: number;
  count: number;
  onSetPage: (page: number) => void;
  pageSize?: number;
}) => {
  const itemsPerPage = pageSize || config.ITEMS_PER_PAGE;
  
  if (itemsPerPage > count) return null;

  return (
    <Flex align="center">
      <ReactPaginate
        page={page}
        count={count}
        pageSize={itemsPerPage}
        onPageChange={(page: number) => onSetPage(page)}
      />
      Page {page + 1} of {Math.ceil(count / itemsPerPage)}
    </Flex>
  );
};

export default Paginate;
